import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { onConsentMaybeInit } from "../lib/analytics";

/**
 * Layout shell for every route — Nestly Layout equivalent.
 * CookieBanner mounts once per page shell after Footer (same structural place as Nestly).
 */
export default function PageShell({ children, hideHeader = false }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  useEffect(() => {
    onConsentMaybeInit();
  }, []);

  return (
    <>
      <a href="#main-content" className="skip-link">
        Vai al contenuto
      </a>
      {!hideHeader && <Header />}
      <main id="main-content" className="pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
